module.exports = __webpack_public_path__ + "static/img/hua2.c049cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua2.png
// module id = 4BMM
// module chunks = 22